import { Injectable } from '@angular/core';

import { ChannelYouTubeInfo } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind, SlideLayout, SlideTimingKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class YouTubeLiveContentProvider implements ContentProvider<ChannelYouTubeInfo> {
  public readonly kind = ContentKind.YoutubeLive;
  public readonly tier = RefreshTier.Main;
  public readonly order = 60;
  public readonly presentation = PresentationSlot.Interrupt;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public async fetch(context: FetchContextModel): Promise<ChannelYouTubeInfo[]> {
    return [await context.source.loadLiveVideo(context.config.channel, context.signal)];
  }

  public toSlides(items: ChannelYouTubeInfo[]): RuntimeSlideModel[] {
    return items.filter(item => item?.isYouTubeChannelLive && !!item.youTubeVideoId).map((item): RuntimeSlideModel => ({
      id: `youtube-live:${item.youTubeVideoId}:live`, kind: this.kind, layout: SlideLayout.Video,
      content: { id: item.id, providerChannelIds: [], videoId: item.youTubeVideoId },
      duration: { kind: SlideTimingKind.Media, expectedMilliseconds: 3600000 }, meta: { sourceId: item.id }
    }));
  }
}
